import { Button } from "@backslashbuild/pp-ui";
import React from "react";

export default function ApproveDraftButton({ onClick }) {
  return (
    <Button
      large
      onClick={() => {
        onClick();
      }}
    >
      Approve Draft
    </Button>
  );
}
